import React, { useEffect } from 'react';
import { EmptyResultComponent } from './EmptyResult';
import { ListItemComponent } from './ListItem';
import { ToggleListItemComponent } from './ToggleListItem';

interface ListDispatchProps {
  fetchListWithAccessDetails: () => void;
  onItemClick: (item) => void;
  chooseItemId?: (item) => string | number;
  chooseItemName?: (item) => string;
  toggleItem: (item) => void;
}

interface ListStateProps {
  list: any;
  emptyListMessage: string;
  searchTerm: string;
}

type ListProps = ListDispatchProps & ListStateProps;

export const ListComponent: React.FC<ListProps> = ({
  fetchListWithAccessDetails,
  list,
  searchTerm,
  emptyListMessage,
  onItemClick,
  toggleItem,
  chooseItemName,
  chooseItemId = item => item.id,
}) => {
  useEffect(() => {
    fetchListWithAccessDetails();
  }, [fetchListWithAccessDetails, searchTerm]);

  return (
    <div className="flex-one flex-box-column">
      {list.length > 0 ? (
        <ul className="access-list ul-list ul-list-with-arrow">
          {list.map(listItem => (
            <ListItemComponent
              chooseItemName={chooseItemName}
              key={chooseItemId(listItem)}
              before={
                <ToggleListItemComponent
                  item={listItem}
                  toggleItem={toggleItem}
                  chooseItemId={chooseItemId}
                  chooseItemName={chooseItemName}
                />
              }
              item={listItem}
              onClick={onItemClick}
            />
          ))}
        </ul>
      ) : (
        <EmptyResultComponent message={searchTerm ? t('message.no-result-found') : emptyListMessage} />
      )}
    </div>
  );
};
